import {useState, useContext} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import {Cookies} from "react-cookie"
import {color_note} from "../Fonctions"
import {ModifTitre} from "./ModifTitre"

export function Activite ({setModal, activite, eleves, effectif}) {

  const {currentUser, setCurrentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)

  const cancres = user.activite_non_faites[eleves[0].classe][activite]
  const cook = new Cookies();
  let auth = {    
    nom:cook.get("nom"),
    prenom:cook.get("prenom"),
    mdp:cook.get("mdp"),
  }
  

  const sendData = () => {
  fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(auth)
    })
    .then(response => response.json())
    .then(data => {
      updateUsercontext()
      setClasses({...classes, param_compte:''})
      setModal(data)
    })
    .catch(err => console.log(err))
  }
  
  const nb_essais = (eleve) => {
    return user.stats[eleve.classe][activite]?.filter(e=>e.id_user === eleve.id_user)[0]?.nb_essais
  } 
  const moyenne = (eleves) => {
    let moy = 0
    let nb_question = 0
    eleves.forEach(e => {
      moy = moy + e.note*e.nb_question
      nb_question = nb_question + e.nb_question*1
    })
    return Math.round(moy*10/nb_question)/10
  }

  const moy = moyenne(eleves) 
  const [classes, setClasses] = useState({
    param_compte:'',
    no_note_compte:'',
  })
  //const [classNoNote, setCalssNoNote] = useState('')
  //const [classParam, setCalssParam] = useState('')

  const handleClick = (e) => {
    const action = classes[e.target.attributes.name?.nodeValue] ? '' : 'active'
    setClasses({...classes, [e.target.attributes.name?.nodeValue]:action})
  }

  const handleSubmit = (e) => {
    const action = e.target.attributes.name.nodeValue
    let field_content = ''
    let field_title = ''
    switch (action) {
      case 'suppr_note_activ':
        let confirm_note = window.confirm("Voulez-vous vraiment supprimer cette note ?");
        if (!confirm_note) {return}
        field_content = e.target.attributes.value.nodeValue
        field_title = e.target.attributes.title.nodeValue
        break;
      case 'suppr_activ':
        let confirm_activ = window.confirm("Voulez-vous vraiment supprimer cette activité ?");
        if (!confirm_activ) {return}
        field_title = e.target.attributes.title.nodeValue
        field_content = eleves[0].classe
        break;
      case 'modif_titre':
        field_content = e.target.previousElementSibling.previousElementSibling.value
        field_title = e.target.previousElementSibling.previousElementSibling.title
        break;
      default:
        console.log(`Aucnu choix de click`);
    }
    auth = {...auth, action, field_content, field_title}
    sendData()
  }

  const dl_info = () => {
    let csv = (eleves[0].title || activite).replaceAll('’','\'').replaceAll('î','i').replaceAll('é','e').replaceAll('è','e')+"\n\n"
    eleves.forEach(e => {
      csv = csv + e.nom + ' ' + e.prenom + ',' + e.note + ',%' +'\n'
    })
    const a = document.getElementById(activite)
    a.href = "data:text/csv;base64," + btoa(csv)
  }

  //console.log('eleves : ', eleves)
  //console.log('user : ', user)
  //console.log('user.stats : ', user.stats)
  //console.log('activite :',  activite)
  return (
    <div className="case compte question_flash">
      <div className="suppr_serie" >
        <input name="suppr_activ" title={activite} type="submit" onClick={handleSubmit} />
      </div>
    	<h1 title={activite.replaceAll('__', '\u000d')}>
        {eleves[0].title || activite.split('__')[0] + (activite.split('__')[1] ? '...' : '')} <br/>
        <span style={{fontSize:"0.8em", fontWeight:"initial", color:"#314159"}}>
          <span title={"Activité faite par "+eleves.length+" élève"+(eleves.length > 1 ? 's' : '')} >{eleves.length}/{effectif} &emsp;&emsp; </span>   
          <span title={"Activité donnée le "+eleves[0].donne_le} >{eleves[0].donne_le} &emsp;&emsp; </span>
          <span className={color_note(moy)} style={{borderBottom:"2px solid"}}>{moy}%</span>
        </span>
      </h1>
    	{eleves.map(e=>
    		<span key={e.id} className={color_note(e.note)} title={e.prenom+' '+e.nom+' : '+e.note+'%\u000d'+e.nb_question+' questions de niveau '+e.etoile+'\u000d'+(nb_essais(e) > 1 ? nb_essais(e)+' essais': nb_essais(e)+' essai')/*+(user.stats[e.classe][activite]?.filter(elv=>elv.identifiant==e.prenom+'.'+e.nom)[0].nbEssaisFull !== '0' ? ('\u000dMeilleur score : '+Math.max(...user.stats[e.classe][activite]?.filter(elv=>elv.identifiant==e.prenom+'.'+e.nom)[0].tryNotes.split('__').map(str=>Number(str)))+'%'):'')*/+'  \u000dLe '+ e.dates} >
    		{e.prenom} : {e.note}% {e.nb_question}q {'⭐'.repeat(e.etoile)} - {e.dates.slice(0,5)}
    		<br/></span>
    		)}
      <div name="param_compte" className="logo_compte param_compte" onClick={handleClick}>⚙️</div>
      <div name="no_note_compte" className="logo_compte no_note_compte" onClick={handleClick} >❗</div>
      <span name="no_note_compte" id="no_note_compte" className={classes.no_note_compte} onClick={handleClick} >
        <div name="no_note_compte" className="suppr_serie" onClick={handleClick}>
        </div>
        <b>{cancres ? 'Activité non faite par '+cancres.length+' élèves :' : 'Tout le groupe a obtenu un score pour cette activité'}</b> <br/>
        {cancres ? '(Avec dernières connexions)' : ''}
        <div style={{columns:"2"}} >                                      
          {cancres?.map(e => <span key={e.id} className={user.stats[eleves[0].classe][activite].map(e=>e.id_user).includes(e.id) ? 'orange' : ''}>{e.prenom} {e.ddc.slice(-2)}/{e.ddc.slice(-5,-3)}<br/></span>)} 
        </div>
      </span>
      <div id="param_compte" className={classes.param_compte} >
        <div name="param_compte" className="suppr_serie close" onClick={handleClick}>
        </div>
        <b>Modifier le titre :</b>
        <br/>
        <ModifTitre auth={{...auth, field_title:activite}} updateUsercontext={updateUsercontext} action={()=>setClasses({...classes, param_compte:''})} title={eleves[0].title} />

        {/*<input type="text" title={activite} placeholder="Nouveau titre" /><br/>
        <input name="modif_titre" type="button" value="Modifier" onClick={handleSubmit} style={{textAlignLast:'center'}} />*/}
        <hr/>
        <b>Sauvegarder les notes :</b> <a id={activite} style={{fontSize:"1.5em", cursor:"pointer"}} onClick={dl_info}>📁</a>
        <hr/>
        <b>Supprimer la note d'un élève :</b><br/>
        {eleves.map(e=>
          <span key={e.id} className={color_note(e.note)} >
            {e.prenom} {e.note}% {e.nb_question}q {'⭐'.repeat(e.etoile)}
            <div className="suppr_serie">
              <input name="suppr_note_activ" title={activite} type="submit" value={e.id_user} onClick={handleSubmit} />
            </div>
          <br/></span>
        )}
      </div>
    </div>
  );
}